import React, { useEffect } from "react";
import Loader from "../../../../../shared-library/components/Loader";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Errormsg from "@frameworks/web/components/generic/errorMsg";
var OutboundRedirection = function () {
    var navigate = useNavigate();
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var clientOverviewData = useSelector(function (state) { return state.Clients.ClientOverview.reducersData.data; });
    var routeToLeadPage = function () {
        navigate("/dashboard/leadpage?selectedAccountCode=" + selectedAcount.accountCode, { replace: true });
    };
    useEffect(function () {
        if (selectedAcount.accountCode &&
            (clientOverviewData === null || clientOverviewData === void 0 ? void 0 : clientOverviewData.isAccountClosed) !== null &&
            (clientOverviewData === null || clientOverviewData === void 0 ? void 0 : clientOverviewData.isAccountClosed) !== undefined &&
            (clientOverviewData === null || clientOverviewData === void 0 ? void 0 : clientOverviewData.isAccountClosed) !== "" &&
            (clientOverviewData === null || clientOverviewData === void 0 ? void 0 : clientOverviewData.isAccountClosed) !== "Y") {
            routeToLeadPage();
        }
    }, [selectedAcount]);
    return (React.createElement(React.Fragment, null,
        !selectedAcount &&
            selectedAcount.accountCode === "" &&
            (clientOverviewData === null || clientOverviewData === void 0 ? void 0 : clientOverviewData.isAccountClosed) !== null &&
            (clientOverviewData === null || clientOverviewData === void 0 ? void 0 : clientOverviewData.isAccountClosed) !== undefined &&
            (clientOverviewData === null || clientOverviewData === void 0 ? void 0 : clientOverviewData.isAccountClosed) !== "" &&
            (clientOverviewData === null || clientOverviewData === void 0 ? void 0 : clientOverviewData.isAccountClosed) === "Y" && (React.createElement(Errormsg, { msg: "No Data Found." })),
        selectedAcount.accountCode && (React.createElement("div", { className: "position-relative client-loader" },
            React.createElement(Loader, null)))));
};
export default OutboundRedirection;
